import {Component, ElementRef, OnDestroy, ViewChild} from "@angular/core";
import {ModalService} from "./services/modal.service";
import {AppMessage } from "./definitions";
import {APP_MESSAGES} from "./enums/enums";
import {Subject} from "rxjs/Subject";
declare var $:any;


@Component({
    selector: 'bs-content',
    templateUrl: "./bs-modal.component.html"
})


export class BsModalComponent implements OnDestroy{
    message:any;


    @ViewChild("errorModal") errorModal:ElementRef;
    @ViewChild("warningModal") warningModal:ElementRef;
    @ViewChild("jsonModal") jsonModal:ElementRef;
    @ViewChild("jsonBody") jsonBody:ElementRef;

    private unsubscribe: Subject<void> = new Subject<void>();

    constructor(private modalService:ModalService) {
        this.modalService.onModalRequest
          .takeUntil(this.unsubscribe)
            .subscribe((appMessage):void => this.handleMessage(appMessage));
    }


    handleMessage(appMessage:AppMessage) {
        switch (appMessage.type) {
            case APP_MESSAGES.ERROR:
                this.error(appMessage.content);
                break;

            case APP_MESSAGES.WARNING:
                this.warning(appMessage.content);
                break;

            case APP_MESSAGES.JSON:
                this.json(appMessage.content);
                break;
        }
        // todo: default
    }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


    private json(json:any) {
        const out:any = JSON.parse(JSON.stringify(json));

        $(this.jsonBody.nativeElement).JSONView(out, { collapsed: false });
        $(this.jsonModal.nativeElement).modal("show");
    }


    private error(error:Error) {
        this.message = "";
        this.message += `message: ${error.message || ""}\n`;
        this.message += `stack: ${error.stack || ""}\n`;

        $(this.errorModal.nativeElement)
          .find("#error_message")
          .text(this.message);

        $(this.errorModal.nativeElement).modal("show");
    }


    private warning(message:string) {
        this.message = message;
        $(this.warningModal.nativeElement).modal("show");
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/bs-modal.component.ts